module.exports = __webpack_public_path__ + "img/mb-ffs-bg.47af3c0.png";